import React, { Component } from 'react';

import CalloutSection from '../Components/CalloutSection'
import Centered from "../Components/Centered";
import TextSection from "../Components/TextSection";
import TopContent from "../Components/TopContent";
import TitleText from "../Components/TitleText";
import LimitedWidthSection from "../Components/LimitedWidthSection";

class Page extends Component {
  render() {
    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <Centered>
              <div className="spacer-40px" />
              <TitleText>Looking for something?</TitleText>
              <div className="spacer-20px" />
              <TextSection>
                <Centered>
                  <div className="spacer-20px" />
                  <LimitedWidthSection>
                    <Centered>
                    <h2>Page Not found</h2>

                    <p>The page you are looking for does not exist <span role="img" aria-label="sad">😕</span></p>
                    </Centered>
                  </LimitedWidthSection>
                  <div className="spacer-40px" />
                </Centered>
              </TextSection>
            </Centered>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/Pages/PageNotFoundPage.js